

import {
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  ToastrService,
  ExportService,
  LoggingService,
  ApplicationLanguagesData,
  ApplicationLangData,
} from "app/shared";
import { BaseChartLogic } from "app/analytics/BaseChartLogic";
import { AppLanguageConfig } from "app/shared/model/charts/user-analytic-configurations.model";

@Component({
  selector: "app-language-chart",
  templateUrl: "../../common-chart-template.component.html",
  standalone: false,
})
export class AppLanguageChartComponent
  extends BaseChartLogic<AppLanguageConfig,ApplicationLanguagesData>
  implements OnInit, OnDestroy
{
  @Input() startDate: Date | null = null;
  @Input() endDate: Date | null = null;
  @Input() showTitle: boolean = true;
  @ViewChild("chartCanvas") chartCanvas!: ElementRef<HTMLCanvasElement>;

  constructor(
    _analyticsService: AnalyticsService,
    _authService: AuthorizationService,
    _exportService: ExportService,
    _toastrService: ToastrService,
    _loggingService: LoggingService,
    _ngZone: NgZone
  ) {
    super(
      _analyticsService,
      _authService,
      _exportService,
      _toastrService,
      _loggingService,
      AppLanguageConfig,
      _ngZone
    );
    this.handleDataSubscription(
      this.analyticsService.applicationLanguagesDataChage
    );
  }

  dataPointKey: string = "Total";
  getDataPointDisplayValue(dataPoint: ApplicationLangData): any {
    return dataPoint.Total;
  }

  buildFilterSettings(): void {
  }

  refreshData(): void {
    this.analyticsService.getApplicationLanguagesData(this.filterSettings);
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }
}
